import { render, staticRenderFns } from "./RoomHeader.vue?vue&type=template&id=63f5120d&lang=pug&"
import script from "./RoomHeader.vue?vue&type=script&lang=js&"
export * from "./RoomHeader.vue?vue&type=script&lang=js&"
import style0 from "./RoomHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports